/* TEMPO — scripts propios (prefijo mt-) */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveals(root) {
    var els = (root || document).querySelectorAll('.mt-reveal, .mt-reveal-img');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('mt-visible'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initParallax() {
    var items = document.querySelectorAll('[data-mt-parallax]');
    if (!items.length || reduce) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      items.forEach(function (el) {
        if (window.innerWidth < 990) { el.style.setProperty('--mt-par', '0px'); return; }
        var r = el.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) return;
        var k = parseFloat(el.getAttribute('data-mt-parallax')) || 0;
        var p = (r.top + r.height / 2 - vh / 2) / vh;
        el.style.setProperty('--mt-par', (-p * k).toFixed(1) + 'px');
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initCounters() {
    var nums = document.querySelectorAll('[data-mt-count]');
    if (!nums.length) return;
    function run(el) {
      var target = parseFloat(el.getAttribute('data-mt-count')) || 0;
      var dec = (String(target).split('.')[1] || '').length;
      var dur = parseInt(el.getAttribute('data-mt-dur'), 10) || 1800;
      if (reduce) { el.textContent = target.toFixed(dec).replace('.', ','); return; }
      var start = null;
      function step(t) {
        if (!start) start = t;
        var p = Math.min((t - start) / dur, 1);
        var e = 1 - Math.pow(1 - p, 4);
        el.textContent = (target * e).toFixed(dec).replace('.', ',');
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) { nums.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.4 });
    nums.forEach(function (n) { io.observe(n); });
  }

  function initGlow() {
    document.querySelectorAll('.mt-cta__box').forEach(function (box) {
      var g = box.querySelector('.mt-cta__glow');
      if (!g || reduce) return;
      box.addEventListener('mousemove', function (ev) {
        var r = box.getBoundingClientRect();
        box.style.setProperty('--gx', ((ev.clientX - r.left) / r.width * 100) + '%');
        box.style.setProperty('--gy', ((ev.clientY - r.top) / r.height * 100) + '%');
      });
    });
  }

  /* ---------- Página de producto ---------- */
  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
    var withDot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    format = format || '{{amount_with_comma_separator}} €';
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount\s*\}\}/, withDot);
  }

  function initGallery(root) {
    var slides = root.querySelector('.mt-pdp__slides');
    if (!slides) return;
    var thumbs = root.querySelectorAll('.mt-pdp__thumb');
    var dots = root.querySelectorAll('.mt-pdp__dots span');
    var count = slides.children.length;
    function current() { return Math.round(slides.scrollLeft / slides.clientWidth); }
    function go(i) {
      i = (i + count) % count;
      slides.scrollTo({ left: i * slides.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
    }
    function mark() {
      var i = current();
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    var prev = root.querySelector('.mt-pdp__nav--prev');
    var next = root.querySelector('.mt-pdp__nav--next');
    if (prev) prev.addEventListener('click', function () { go(current() - 1); });
    if (next) next.addEventListener('click', function () { go(current() + 1); });
    var t;
    slides.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(mark, 60); }, { passive: true });
    root.goToMedia = function (mediaId) {
      var idx = -1;
      Array.prototype.forEach.call(slides.children, function (s, k) { if (s.getAttribute('data-media-id') == mediaId) idx = k; });
      if (idx > -1) go(idx);
    };
  }

  function initProduct(root) {
    var dataEl = root.querySelector('[data-mt-product-json]');
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var moneyFormat = root.getAttribute('data-money-format');
    var form = root.querySelector('form[data-mt-form]');
    var idInput = form.querySelector('input[name="id"]');
    var btns = root.querySelectorAll('[data-mt-add]');
    var priceNow = root.querySelectorAll('[data-mt-price]');
    var priceOld = root.querySelectorAll('[data-mt-compare]');
    var save = root.querySelector('[data-mt-save]');
    var msg = root.querySelector('[data-mt-msg]');
    var txtAdd = root.getAttribute('data-txt-add');
    var txtSold = root.getAttribute('data-txt-sold');
    var txtSave = root.getAttribute('data-txt-save') || '';

    function selected() {
      var opts = [];
      root.querySelectorAll('.mt-pdp__opt').forEach(function (fs) {
        var c = fs.querySelector('input:checked');
        if (c) opts.push(c.value);
        var lab = fs.querySelector('legend span');
        if (lab && c) lab.textContent = c.value;
      });
      return opts;
    }

    function update() {
      var opts = selected();
      var v = product.variants.find(function (x) {
        return x.options.every(function (o, i) { return o === opts[i]; });
      });
      if (!v) {
        btns.forEach(function (b) { b.disabled = true; b.querySelector('span').textContent = txtSold; });
        return;
      }
      idInput.value = v.id;
      priceNow.forEach(function (p) { p.textContent = formatMoney(v.price, moneyFormat); });
      var has = v.compare_at_price && v.compare_at_price > v.price;
      priceOld.forEach(function (p) { p.textContent = has ? formatMoney(v.compare_at_price, moneyFormat) : ''; p.hidden = !has; });
      if (save) {
        save.hidden = !has;
        if (has) save.textContent = txtSave.replace('[ahorro]', formatMoney(v.compare_at_price - v.price, moneyFormat)).replace('[porcentaje]', Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%');
      }
      btns.forEach(function (b) { b.disabled = !v.available; b.querySelector('span').textContent = v.available ? txtAdd : txtSold; });
      if (v.featured_media && root.goToMedia) root.goToMedia(v.featured_media.id);
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    root.querySelectorAll('.mt-pdp__opt input').forEach(function (i) { i.addEventListener('change', update); });

    var qty = root.querySelector('.mt-qty input, [data-mt-pack-qty]');
    var pc = root.querySelector('[data-mt-packcol]');
    var pcRows = pc && pc.querySelector('[data-mt-packcol-rows]');
    var unitIds = [];
    function renderPackImgs() {
      var mainId = parseInt(idInput.value, 10);
      var imgOf = function (id) { var x = product.variants.find(function (y) { return y.id === id; }); return x && (x.cut || x.img); };
      var checked = root.querySelector('[data-mt-packs] input:checked');
      root.querySelectorAll('[data-mt-pack-img]').forEach(function (box) {
        var n = parseInt(box.getAttribute('data-mt-pack-img'), 10) || 1;
        var mine = checked && box.closest('.mt-pack') === checked.closest('.mt-pack') && unitIds.length === n;
        var imgs = box.querySelectorAll('img');
        for (var k = 0; k < n; k++) { var src = imgOf(mine ? unitIds[k] : mainId); if (src && imgs[k] && imgs[k].getAttribute('data-src') !== src) { imgs[k].removeAttribute('srcset'); imgs[k].src = src; imgs[k].setAttribute('data-src', src); } }
      });
    }
    function renderPackCol() { renderPackColInner(); renderPackImgs(); }
    function renderPackColInner() {
      if (!pc || !qty) return;
      var n = parseInt(qty.value, 10) || 1;
      var vs = product.variants.filter(function (x) { return x.available; });
      var dyn = root.querySelector('.mt-pdp__dynamic');
      if (n < 2 || vs.length < 2) { pc.hidden = true; unitIds = []; if (dyn) dyn.hidden = false; return; }
      var cur = parseInt(idInput.value, 10);
      while (unitIds.length < n) unitIds.push(cur);
      unitIds.length = n;
      pc.hidden = false;
      pcRows.innerHTML = '';
      unitIds.forEach(function (sel, i) {
        var row = document.createElement('div'); row.className = 'mt-packcol__row';
        var lab = document.createElement('span'); lab.className = 'mt-packcol__n'; lab.textContent = 'Unidad ' + (i + 1);
        var list = document.createElement('div'); list.className = 'mt-packcol__list';
        vs.forEach(function (v) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'mt-packcol__sw' + (v.id === sel ? ' is-on' : '');
          b.title = v.options.join(' / '); b.setAttribute('aria-label', 'Unidad ' + (i + 1) + ': ' + b.title);
          if (v.img) { var im = document.createElement('img'); im.src = v.img; im.alt = ''; b.appendChild(im); } else { b.textContent = v.options[0]; }
          b.addEventListener('click', function () { unitIds[i] = v.id; renderPackCol(); });
          list.appendChild(b);
        });
        var nm = document.createElement('span'); nm.className = 'mt-packcol__name';
        var vv = vs.find(function (x) { return x.id === sel; }); nm.textContent = vv ? vv.options.join(' / ') : '';
        row.appendChild(lab); row.appendChild(list); row.appendChild(nm);
        pcRows.appendChild(row);
      });
      if (dyn) dyn.hidden = unitIds.some(function (id) { return id !== unitIds[0]; });
    }
    root.querySelectorAll('[data-mt-packs] input[type="radio"]').forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked && qty) { qty.value = r.value; renderPackCol(); } });
    });
    root.querySelectorAll('.mt-pdp__opt input').forEach(function (i) { i.addEventListener('change', function () { unitIds = []; renderPackCol(); }); });
    renderPackCol();
    root.querySelectorAll('.mt-qty button').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = parseInt(qty.value, 10) || 1;
        n = b.getAttribute('data-dir') === '+' ? n + 1 : Math.max(1, n - 1);
        qty.value = n;
      });
    });

    function add(btn) {
      var drawer = document.querySelector('cart-drawer');
      var items = [{ id: parseInt(idInput.value, 10), quantity: qty ? Math.max(1, parseInt(qty.value, 10) || 1) : 1 }];
      if (pc && !pc.hidden && unitIds.length) {
        var cuenta = {};
        unitIds.forEach(function (id) { cuenta[id] = (cuenta[id] || 0) + 1; });
        items = Object.keys(cuenta).map(function (k) { return { id: parseInt(k, 10), quantity: cuenta[k] }; });
      }
      var body = { items: items };
      if (drawer) { body.sections = ['cart-drawer', 'cart-icon-bubble']; body.sections_url = window.location.pathname; }
      btn.classList.add('is-loading');
      if (msg) msg.textContent = '';
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
      }).then(function (r) { return r.json(); }).then(function (res) {
        btn.classList.remove('is-loading');
        if (res.status && res.description) { if (msg) msg.textContent = res.description; return; }
        if (drawer && res.sections && typeof drawer.renderContents === 'function') {
          if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
          drawer.renderContents(res);
        } else {
          window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
        }
      }).catch(function () { btn.classList.remove('is-loading'); form.submit(); });
    }

    form.addEventListener('submit', function (e) { e.preventDefault(); add(form.querySelector('[data-mt-add]')); });
    var sticky = root.querySelector('.mt-sticky');
    if (sticky) {
      var sb = sticky.querySelector('[data-mt-add]');
      sb.addEventListener('click', function () { add(sb); });
      var main = form.querySelector('[data-mt-add]');
      if ('IntersectionObserver' in window) {
        var fuera = false;
        var movil = window.matchMedia('(max-width: 749px)');
        var pinta = function () { sticky.classList.toggle('is-visible', fuera && (!movil.matches || window.scrollY > 220)); };
        var io = new IntersectionObserver(function (en) { fuera = !en[0].isIntersecting; pinta(); });
        io.observe(main);
        window.addEventListener('scroll', pinta, { passive: true });
      }
    }
  }

  function initQuickAdd() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest ? e.target.closest('form[data-mt-quick]') : null;
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      var drawer = document.querySelector('cart-drawer');
      var body = { items: [{ id: parseInt(form.querySelector('input[name="id"]').value, 10), quantity: 1 }] };
      if (drawer) { body.sections = ['cart-drawer', 'cart-icon-bubble']; body.sections_url = window.location.pathname; }
      if (btn) btn.classList.add('is-loading');
      var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (btn) btn.classList.remove('is-loading');
          if (res.status && res.description) { alert(res.description); return; }
          if (drawer && res.sections && typeof drawer.renderContents === 'function') drawer.renderContents(res);
          else window.location.href = root + 'cart';
        })
        .catch(function () { if (btn) btn.classList.remove('is-loading'); form.submit(); });
    });
  }

  function initCerca(scope) {
    (scope || document).querySelectorAll('[data-mt-cerca]').forEach(function (root) {
      var parts = root.querySelectorAll('.mt-cerca__dot, .mt-cerca__tip, .mt-cerca__item');
      function show(i) {
        parts.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-i') === String(i)); });
      }
      root.querySelectorAll('.mt-cerca__dot, .mt-cerca__item').forEach(function (el) {
        var i = el.getAttribute('data-i');
        el.addEventListener('mouseenter', function () { show(i); });
        el.addEventListener('click', function () { show(i); });
      });
      show(0);
    });
  }

  function initEntrega() {
    var meses = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
    document.querySelectorAll('[data-mt-entrega]').forEach(function (el) {
      function fecha(d) {
        var f = new Date(), n = 0;
        while (n < d) { f.setDate(f.getDate() + 1); if (f.getDay() !== 0 && f.getDay() !== 6) n++; }
        return f;
      }
      var a = fecha(parseInt(el.getAttribute('data-min'), 10) || 5);
      var b = fecha(parseInt(el.getAttribute('data-max'), 10) || 10);
      var ta = a.getDate() + (a.getMonth() === b.getMonth() ? '' : ' de ' + meses[a.getMonth()]);
      var tb = b.getDate() + ' de ' + meses[b.getMonth()];
      var d1 = el.querySelector('[data-desde]'), d2 = el.querySelector('[data-hasta]');
      if (d1) d1.textContent = ta;
      if (d2) d2.textContent = tb;
    });
  }

  function initAll() {
    initEntrega();
    initCerca();
    initQuickAdd();
    initReveals();
    initParallax();
    initCounters();
    initGlow();
    document.querySelectorAll('[data-mt-pdp]').forEach(function (r) { initGallery(r); initProduct(r); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', function (e) {
    initReveals(e.target);
    initCerca(e.target);
    initCounters();
    e.target.querySelectorAll('[data-mt-pdp]').forEach(function (r) { initGallery(r); initProduct(r); });
  });
})();
